module.exports = __webpack_public_path__ + "static/media/lakers_logo.ba529143.png";